export enum ExternalPaymentType {
  Cash = 'cash',
  Card = 'card',
}
